module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/LesMiserables_Horiz.b457997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/LesMiserables_Horiz.jpg
// module id = DCGV
// module chunks = 0